<!-- Modal backdrop -->
<div class="modal-backdrop fade show"></div>

<!-- Centered modal -->
<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal body -->
      <div class="modal-body container-fluid">
        <h5 class="mb-4 text-center">{{ lead ? 'Edit Lead' : 'Create Lead' }}</h5>

        <form [formGroup]="leadForm" (ngSubmit)="onSubmit()">
          <div class="row gy-3 gx-2">

            <div class="col-12 col-md-6">
              <label class="form-label">Business Name</label>
              <input class="form-control" formControlName="businessName" />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Contact Name</label>
              <input class="form-control" formControlName="contactName" />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Contact Number</label>
                <input
                type="text"
                class="form-control"
                formControlName="contactNumber"
                mask="(000) 000-0000"
                [dropSpecialCharacters]="false"
                [showMaskTyped]="true"
                autocomplete="tel"
                placeholder="(123) 456-7890"
                />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Contact Email</label>
              <input type="email" class="form-control" formControlName="contactEmail" />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Status</label>
              <select class="form-select" formControlName="status">
                <option *ngFor="let status of leadStatuses" [value]="status">{{ status }}</option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Interested Machine Count</label>
              <input type="number" class="form-control" formControlName="interestedMachineCount" />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Closed Machine Count</label>
              <input type="number" class="form-control" formControlName="closedMachineCount" />
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Expected Delivery Date</label>
              <input type="date" class="form-control" formControlName="expectedDeliveryDate" />
            </div>
            <div class="col-12">
            <label class="form-label">Assigned Sales Rep</label>
            <select class="form-select" formControlName="assignedSalesRepId">
                <option value="">-- Select Sales Rep --</option>
                <option value="new-rep">Potential New Sales Rep</option> <!-- custom static option -->
                <option *ngFor="let rep of salesReps" [value]="rep.id">
                {{ formatRepName(rep) }}
                </option>
            </select>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-secondary me-2" (click)="onClose()">Cancel</button>
            <button type="submit" class="btn btn-primary">{{ lead ? 'Update' : 'Create' }}</button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>
